import { createSelector } from 'reselect'
import { actionTypeCreator } from './util'

// /////////////////////////////////////////////////////////////////////////////
// Constants
// /////////////////////////////////////////////////////////////////////////////
export const constants = {
  NAME: 'aliada'
}

// /////////////////////////////////////////////////////////////////////////////
// Action Types
// /////////////////////////////////////////////////////////////////////////////
const createActionType = actionTypeCreator.bind(null, constants.NAME)
export const FETCH = createActionType('FETCH')
export const FETCH_IF_NEEDED = createActionType('FETCH_IF_NEEDED')
export const FETCH_STARTED = createActionType('FETCH_STARTED')
export const FETCH_SUCCESS = createActionType('FETCH_SUCCESS')
export const FETCH_FAILURE = createActionType('FETCH_FAILURE')

// /////////////////////////////////////////////////////////////////////////////
// Actions
// /////////////////////////////////////////////////////////////////////////////
export function fetchAliada (aliadaId, filters) {
  return {
    type: FETCH,
    payload: {
      aliadaId,
      filters
    }
  }
}

export function fetchAliadaIfNeeded (aliadaId) {
  return {
    type: FETCH_IF_NEEDED,
    payload: {
      aliadaId
    }
  }
}

// /////////////////////////////////////////////////////////////////////////////
// Selectors
// /////////////////////////////////////////////////////////////////////////////
export const getState = (state) => state[constants.NAME]

// /////////////////////////////////////////////////////////////////////////////
// Queries
// /////////////////////////////////////////////////////////////////////////////
export const isFetching = createSelector(
  getState,
  (state) => state.fetching
)

// /////////////////////////////////////////////////////////////////////////////
// Reducer
// /////////////////////////////////////////////////////////////////////////////
const initialState = {
  fetching: false
}
export function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        fetching: true
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        fetching: false
      }
    case FETCH_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload.status
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/aliada.js